export default function (event) {
  event.preventDefault();

  const clickedElement = event.target.closest('span');
  const inputElement = clickedElement.parentElement.querySelector('input');
  
  if (!inputElement) { return };

  const currentValue = parseInt(inputElement.value) || 0;
  const increment = parseInt(clickedElement.dataset.value);
  const newValue = currentValue + increment;
  const min = parseInt(inputElement.min) || 0;
  const max = parseInt(inputElement.max) || 9;

  if (newValue >= min && newValue <= max) {
    inputElement.value = newValue;
    inputElement.dispatchEvent(new Event('input', { bubbles: true }));
    inputElement.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
